module.exports = __webpack_public_path__ + "static/media/822a4b92-b1b8-4a24-869e-d21f244dcd81.9c6be8be.JPG";